import React from 'react';
import { TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';

/**
 * Slim progress strip that sits glued to the bottom of the header and, once
 * the header scrolls away, sticks to the top of the viewport.
 */
const ProgressBar = ({ completed, total }) => {
  const percentage = total > 0 ? Math.round((completed / total) * 100) : 0;

  return (
    <div className="xz-progress-strip sticky top-0 z-40 glass border-x-0 border-t-0">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center gap-3">
        <span className="hidden sm:flex items-center gap-1.5 text-xs font-semibold text-cyan-300 flex-shrink-0">
          <TrendingUp className="w-4 h-4 text-yellow-400" />
          Progress
        </span>
        <div
          className="flex-1 bg-gray-700/70 rounded-full h-2 overflow-hidden"
          role="progressbar"
          aria-valuenow={percentage}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label="Overall progress"
        >
          <motion.div
            className="h-full rounded-full brand-gradient"
            initial={{ width: 0 }}
            animate={{ width: `${percentage}%` }}
            transition={{ type: 'spring', stiffness: 120, damping: 20 }}
          />
        </div>
        <span className="font-display text-lg font-semibold text-yellow-400 leading-none tabular-nums flex-shrink-0">
          {percentage}%
        </span>
        <span className="text-[11px] text-gray-400 flex-shrink-0 hidden xs:inline sm:inline">
          {completed} of {total} days
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;
